module.exports = __webpack_public_path__ + "static/media/gu.8fea666e.png";